import type { Strings } from "../i18n/strings";
import { hyuhPromoVisible, openHyuh } from "../lib/crossPromo";

// hyuh 크로스프로모 배너. 결과 상세 하단·설정에만(입력 화면 제외). 톤은 차분하게(hyuh = 위로의 밤) —
// bwek의 레드/광고 슬롯과 분리. 토스·미승인 iOS에선 hyuhPromoVisible()이 false → 렌더 안 함.
// 왼쪽에 hyuh 달 아이콘(인라인 SVG)을 둬서 '앱'임을 한눈에.
export default function HyuhPromo({ t, place }: { t: Strings; place: "result" | "settings" }) {
  if (!hyuhPromoVisible()) return null;
  const copy = place === "result" ? t.hyuhResult : t.hyuhSettings;
  return (
    <button
      className="hyuh-promo"
      onClick={() => openHyuh(place === "result" ? "bwek_result" : "bwek_settings")}
    >
      <svg className="hyuh-promo-moon" viewBox="0 0 30 30" aria-hidden="true">
        <defs>
          <radialGradient id="hyuhMoonGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#f3e6c0" stopOpacity="0.45" />
            <stop offset="100%" stopColor="#f3e6c0" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="hyuhMoonBody" cx="63%" cy="40%" r="68%">
            <stop offset="0%" stopColor="#fdf6e3" />
            <stop offset="50%" stopColor="#e6d3a3" />
            <stop offset="100%" stopColor="#b09a6b" />
          </radialGradient>
        </defs>
        <circle cx="15" cy="15" r="14" fill="url(#hyuhMoonGlow)" />
        <circle cx="15" cy="14" r="10" fill="url(#hyuhMoonBody)" />
      </svg>
      <span className="hyuh-promo-text">{copy}</span>
      <span className="hyuh-promo-arrow" aria-hidden="true">
        ↗
      </span>
    </button>
  );
}
